import { render } from "./Sale_Arrears.vue?vue&type=template&id=13e10a98"
import script from "./Sale_Arrears.vue?vue&type=script&lang=js"
export * from "./Sale_Arrears.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__